import ActionType from '../action-types';

const initialState = {
  customers_loading: false,
  customers_error: null,
  customers_success: false,
  customers: null,
  customers_page: 1,
  customers_per_page: 20,
  customers_total: 0,
  retailers: null,
  retailersPage: 1,
  retailersPerPage: 20,
  retailersTotal: 0,
  retailersLoading: false,
  retailersError: null,
  endUsers: null,
  endUsersPage: 1,
  endUsersPerPage: 20,
  endUsersTotal: 0,
  endUsersLoading: false,
  endUsersError: null,
  searchResults: null,
  searchResultsLoading: false,
  searchResultsError: null,
  customerView: 'retailers'
};

// eslint-disable-next-line default-param-last
const customersReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.FETCH_CUSTOMERS_START:
      return {
        ...state,
        customers_loading: true,
        customers_error: null,
        customers_success: false,
        customers: null,
        customers_page: action.payload.page
      };
    case ActionType.FETCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers_loading: false,
        customers_error: null,
        customers_success: true,
        customers: action.payload.data,
        customers_total: action.payload.total,
        customers_per_page: action.payload.per_page
      };
    case ActionType.FETCH_CUSTOMERS_ERROR:
      return {
        ...state,
        customers_loading: false,
        customers_error: action.payload,
        customers_success: false,
        customers: null,
        customers_page: 1,
        customers_total: 0,
        customers_per_page: 20
      };
    case ActionType.FETCH_RETAILERS_START:
      return {
        ...state,
        retailersLoading: true,
        retailersError: null,
        retailers: null,
        retailersPage: action.payload.page
      };
    case ActionType.FETCH_RETAILERS_SUCCESS:
      return {
        ...state,
        retailersLoading: false,
        retailersError: null,
        retailers: action.payload.data,
        retailersTotal: action.payload.total,
        retailersPerPage: action.payload.per_page
      };
    case ActionType.FETCH_RETAILERS_ERROR:
      return {
        ...state,
        retailersLoading: false,
        retailersError: action.payload,
        retailersPage: 1,
        retailersTotal: 0,
        retailers: null,
        retailersPerPage: 20
      };
    case ActionType.FETCH_ENDUSERS_START:
      return {
        ...state,
        endUsersLoading: true,
        endUsersError: null,
        endUsers: null,
        endUsersPage: action.payload.page
      };
    case ActionType.FETCH_ENDUSERS_SUCCESS:
      return {
        ...state,
        endUsersLoading: false,
        endUsersError: null,
        endUsers: action.payload.data,
        endUsersTotal: action.payload.total,
        endUsersPerPage: action.payload.per_page
      };
    case ActionType.FETCH_ENDUSERS_ERROR:
      return {
        ...state,
        endUsersLoading: false,
        endUsersError: action.payload,
        endUsers: null,
        endUsersPage: 1,
        endUsersTotal: 0,
        endUsersPerPage: 20
      };
    case ActionType.FETCH_CUSTOMER_SEARCH_START:
      return {
        ...state,
        searchResultsLoading: true,
        searchResultsError: null,
        searchResults: null
      };
    case ActionType.FETCH_CUSTOMER_SEARCH_SUCCESS:
      return {
        ...state,
        searchResultsLoading: false,
        searchResultsError: null,
        searchResults: action.payload.data
      };
    case ActionType.FETCH_CUSTOMER_SEARCH_ERROR:
      return {
        ...state,
        searchResultsLoading: false,
        searchResultsError: action.payload,
        searchResults: null
      };
    case ActionType.SET_CUSTOMER_VIEW:
      return {
        ...state,
        customerView: action.payload.view
      };
    default:
      return state;
  }
};

export default customersReducer;
